import HeroWrapper from 'components/Banner/HeroBanner/HeroWrapper/HeroWrapper';
import { default as HeroA } from 'components/Banner/HeroBanner/TypeA/TypeA';
import { default as HeroA4 } from 'components/Banner/HeroBanner/TypeA4/TypeA4';
import { default as HeroB } from 'components/Banner/HeroBanner/TypeB/TypeB';
import { default as HeroC } from 'components/Banner/HeroBanner/TypeC/TypeC';
import { default as HeroDWrapper } from 'components/Banner/HeroBanner/TypeD/TypeDWrapper';
import { default as HeroD } from 'components/Banner/HeroBanner/TypeD/TypeD';
import { default as HeroE } from 'components/Banner/HeroBanner/TypeE/TypeE';
import { default as HeroMapSection } from 'components/Banner/HeroBanner/MapSection/MapSection';

export {
  HeroWrapper,
  HeroA,
  HeroA4,
  HeroB,
  HeroC,
  HeroDWrapper,
  HeroD,
  HeroE,
  HeroMapSection    
};



// WEBPACK FOOTER //
// ./src/uis/components/Banner/HeroBanner/index.js